import { useParams, Navigate } from "react-router-dom";
import { INDUSTRIES_V2, findIndustry } from "@/data/solutions";
import { INDUSTRY_ICONS } from "@/components/LineIcons";
import EntityDetailPage from "@/components/EntityDetailPage";
import SEO from "@/components/SEO";
import { TESTIDS } from "@/constants/testIds";

export default function IndustryDetail() {
    const { id } = useParams();
    const ind = findIndustry(id);
    if (!ind) return <Navigate to="/industries" replace />;

    const siblings = INDUSTRIES_V2.map((x) => ({
        id: x.id,
        name: x.name,
        path: `/industries/${x.id}`,
        icon: INDUSTRY_ICONS[x.id],
        current: x.id === id,
    }));

    return (
        <>
            <SEO
                path={`/industries/${ind.id}`}
                title={`AI for ${ind.name}, KyroLabs`}
                description={ind.long}
            />
            <EntityDetailPage
                testId={TESTIDS.industries.card(ind.id)}
                kicker="Industry"
                title={ind.name}
                tagline={ind.short}
                body={ind.long}
                subItems={ind.focusAreas}
                subLabel="Focus areas"
                accent={ind.color}
                image={ind.image}
                bookSource={`industries-detail:${ind.id}`}
                siblings={siblings}
                siblingsLabel="Explore industries"
            />
        </>
    );
}
